let wasm
let WASM_VECTOR_LEN = 0
let cachegetUint8Memory0 = null
function getUint8Memory0() {
  if (
    cachegetUint8Memory0 === null ||
    cachegetUint8Memory0.buffer !== wasm.memory.buffer
  ) {
    cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer)
  }
  return cachegetUint8Memory0
}
let cachedTextEncoder = new TextEncoder('utf-8')
const encodeString =
  typeof cachedTextEncoder.encodeInto === 'function'
    ? function(arg, view) {
        return cachedTextEncoder.encodeInto(arg, view)
      }
    : function(arg, view) {
        const buf = cachedTextEncoder.encode(arg)
        view.set(buf)
        return {
          read: arg.length,
          written: buf.length,
        }
      }
function passStringToWasm0(arg, malloc, realloc) {
  if (realloc === undefined) {
    const buf = cachedTextEncoder.encode(arg)
    const ptr = malloc(buf.length)
    getUint8Memory0()
      .subarray(ptr, ptr + buf.length)
      .set(buf)
    WASM_VECTOR_LEN = buf.length
    return ptr
  }
  let len = arg.length
  let ptr = malloc(len)
  const mem = getUint8Memory0()
  let offset = 0
  for (; offset < len; offset++) {
    const code = arg.charCodeAt(offset)
    if (code > 0x7f) break
    mem[ptr + offset] = code
  }
  if (offset !== len) {
    if (offset !== 0) {
      arg = arg.slice(offset)
    }
    ptr = realloc(ptr, len, (len = offset + arg.length * 3))
    const view = getUint8Memory0().subarray(ptr + offset, ptr + len)
    const ret = encodeString(arg, view)
    offset += ret.written
  }
  WASM_VECTOR_LEN = offset
  return ptr
}
let cachegetInt32Memory0 = null
function getInt32Memory0() {
  if (
    cachegetInt32Memory0 === null ||
    cachegetInt32Memory0.buffer !== wasm.memory.buffer
  ) {
    cachegetInt32Memory0 = new Int32Array(wasm.memory.buffer)
  }
  return cachegetInt32Memory0
}
let cachedTextDecoder = new TextDecoder('utf-8', {
  ignoreBOM: true,
  fatal: true,
})
cachedTextDecoder.decode()
function getStringFromWasm0(ptr, len) {
  return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len))
}
/**
 * @param {string} _seed
 * @param {string} vd
 * @param {string} fk
 * @param {string} sk
 * @param {string} tweak
 * @param {string} _t
 * @param {number} _rate
 * @returns {string}
 */
export function fetch_seed(_seed, vd, fk, sk, tweak, _t, _rate) {
  try {
    const retptr = wasm.__wbindgen_add_to_stack_pointer(-16)
    var ptr0 = passStringToWasm0(
      _seed,
      wasm.__wbindgen_malloc,
      wasm.__wbindgen_realloc
    )
    var len0 = WASM_VECTOR_LEN
    var ptr1 = passStringToWasm0(
      vd,
      wasm.__wbindgen_malloc,
      wasm.__wbindgen_realloc
    )
    var len1 = WASM_VECTOR_LEN
    var ptr2 = passStringToWasm0(
      fk,
      wasm.__wbindgen_malloc,
      wasm.__wbindgen_realloc
    )
    var len2 = WASM_VECTOR_LEN
    var ptr3 = passStringToWasm0(
      sk,
      wasm.__wbindgen_malloc,
      wasm.__wbindgen_realloc
    )
    var len3 = WASM_VECTOR_LEN
    var ptr4 = passStringToWasm0(
      tweak,
      wasm.__wbindgen_malloc,
      wasm.__wbindgen_realloc
    )
    var len4 = WASM_VECTOR_LEN
    var ptr5 = passStringToWasm0(
      _t,
      wasm.__wbindgen_malloc,
      wasm.__wbindgen_realloc
    )
    var len5 = WASM_VECTOR_LEN
    wasm.fetch_seed(
      retptr,
      ptr0,
      len0,
      ptr1,
      len1,
      ptr2,
      len2,
      ptr3,
      len3,
      ptr4,
      len4,
      ptr5,
      len5,
      _rate
    )
    var r0 = getInt32Memory0()[retptr / 4 + 0]
    var r1 = getInt32Memory0()[retptr / 4 + 1]
    return getStringFromWasm0(r0, r1)
  } finally {
    wasm.__wbindgen_add_to_stack_pointer(16)
    wasm.__wbindgen_free(r0, r1)
  }
}
async function load(module, imports) {
  if (typeof Response === 'function' && module instanceof Response) {
    if (typeof WebAssembly.instantiateStreaming === 'function') {
      try {
        return await WebAssembly.instantiateStreaming(module, imports)
      } catch (e) {
        if (module.headers.get('Content-Type') != 'application/wasm') {
          console.warn(
            '`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n',
            e
          )
        } else {
          throw e
        }
      }
    }
    const bytes = await module.arrayBuffer()
    return await WebAssembly.instantiate(bytes, imports)
  } else {
    const instance = await WebAssembly.instantiate(module, imports)
    if (instance instanceof WebAssembly.Instance) {
      return { instance, module }
    } else {
      return instance
    }
  }
}
export async function init(input) {
  if (typeof input === 'undefined') {
    input = new URL(
      'unionpaycode_rust_bg.wasm',
      'https://s3plus.meituan.net/v1/mss_737138c80ced4307aa7daa44e910ba1b/union-pay/'
    )
  }
  const imports = {}
  if (
    typeof input === 'string' ||
    (typeof Request === 'function' && input instanceof Request) ||
    (typeof URL === 'function' && input instanceof URL)
  ) {
    input = fetch(input)
  }
  const { instance, module } = await load(await input, imports)
  wasm = instance.exports
  init.__wbindgen_wasm_module = module
  return wasm
}